import React from "react";

type Props = {
  label?: string;
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "price" | "text";
};

const TextInput: React.FC<Props> = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
}) => {
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    if (type === "price") {
      // Remove all non-digit characters
      const digitsOnly = newValue.replace(/[^\d]/g, "");
      onChange(digitsOnly);
    } else {
      onChange(newValue);
    }
  };

  const getValue = (value: string) => {
    if (type === "price") return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="w-full mb-4">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        type="text"
        value={getValue(value?.toString())}
        onChange={changeHandler}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
};

export default TextInput;
